export default __webpack_public_path__ + "static/media/so.9140c976.svg";